import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "challenge-card" }
const _hoisted_2 = { class: "image-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "date-value" }
const _hoisted_7 = { class: "aligned-content" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_9 = {
  key: 0,
  class: "aligned-content"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "card-footer" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  type: "button",
  class: "btn btn-primary",
  disabled: ""
}
const _hoisted_14 = {
  key: 2,
  type: "button",
  class: "btn btn-primary",
  disabled: ""
}
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calendar_icon = _resolveComponent("calendar-icon")!
  const _component_trophy_icon = _resolveComponent("trophy-icon")!
  const _component_arrow_right = _resolveComponent("arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.image,
        alt: "",
        class: "card-image"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_calendar_icon),
            _createElementVNode("span", null, _toDisplayString(_ctx.startDate), 1),
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.endDate), 1)
          ]),
          (_ctx.valued)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createVNode(_component_trophy_icon, { class: "icon" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('challengeCard.valued')) + " " + _toDisplayString(_ctx.formattedValue), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("p", { innerHTML: _ctx.description }, null, 8, _hoisted_10),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.buttonState === _ctx.ButtonStates.APPLY)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.applyUrl,
              type: "button",
              class: "btn btn-primary"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('challengeCard.applyNow')), 1),
              _createVNode(_component_arrow_right)
            ], 8, _hoisted_12))
          : (_ctx.buttonState === _ctx.ButtonStates.CLOSED)
            ? (_openBlock(), _createElementBlock("button", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('challengeCard.closed')), 1)
              ]))
            : (_openBlock(), _createElementBlock("button", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('challengeCard.comingSoon')), 1)
              ])),
        _createElementVNode("a", {
          href: _ctx.discoverUrl,
          type: "button",
          class: "btn btn--text btn-text-dark"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('challengeCard.discoverMore')), 1),
          _createVNode(_component_arrow_right)
        ], 8, _hoisted_15)
      ])
    ])
  ]))
}